module.exports = __webpack_public_path__ + "static/logo-white-31a927e6fa6b09bf351c78ae04c4b2f4.svg";